import React from "react";
import { Col, Row } from "antd";
import style from "../../index.module.scss";
import Editor from "components/Editor";
import { indexToChar } from "../../../../../../../../../../utils/common";

interface QuestionOptionProps {
    index: number;
    showRemove: boolean;
    value: string;
    onChange: (index: number, text: string) => void;
    onRemove: (index: number) => void;
    error?: string;
}

const QuestionOption = React.memo(function QuestionOption({
    index,
    showRemove,
    value,
    onChange,
    onRemove,
    error
}: QuestionOptionProps) {
    function optionChar(index: number) {
        return indexToChar(index);
    }

    return (
        <Row key={index} gutter={[0, 20]}>
            <Col span={4} className={style.label}>
                选项{optionChar(index)}
            </Col>

            <Col span={18} offset={1}>
                <Editor data={value} onChange={text => onChange(index, text)} />

                <div className={style.error}>{error}</div>
            </Col>

            {showRemove && (
                <Col span={1}>
                    <button
                        type="button"
                        className={style.btnDelete}
                        onClick={() => onRemove(index)}
                    />
                </Col>
            )}
        </Row>
    );
});

export default QuestionOption;
